import { useAuthStore } from '@/store/auth';

export default function guest(to, from, next) {
    const authStore = useAuthStore();

    //Directly check the reactive isAuthenticated state from the auth store
    if (authStore.isAuthenticated) {
        // Signed in already: the team to the panel, everyone else to the Academy
        return next(authStore.homeRoute);
    }

    // User is not authenticated, proceed with the navigation
    return next();
}
